/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_DeleteInputs */

const cs_settings_teams_delete = /** @type {(inputs: Settings_Teams_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat tým`)
};

const en_settings_teams_delete = /** @type {(inputs: Settings_Teams_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete team`)
};

/**
* | output |
* | --- |
* | "Delete team" |
*
* @param {Settings_Teams_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete = /** @type {((inputs?: Settings_Teams_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete(inputs)
	return cs_settings_teams_delete(inputs)
});